module.exports = __webpack_public_path__ + "img/lg_ring_y_0_null_null.07bafa10.png";